import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatIsoDate';

export default function formateCommandeAchatBailleurForUpdate(commandeToFormate) {
  const commande = cloneDeep(commandeToFormate);
  commande.dateDevisCommande = formatDate(commande.dateDevisCommande);
  commande.datePremierAffichage = formatDate(commande.datePremierAffichage);
  commande.dateRenouvellement = formatDate(commande.dateRenouvellement);
  commande.dateValidite = formatDate(commande.dateValidite);
  commande.lignesCommande = commande.lignesCommande.filter(l => !l.total);
  commande.lignesCommande.forEach((ligne) => {
    ligne.dateDebut = formatDate(ligne.dateDebut);
    ligne.dateFin = formatDate(ligne.dateFin);
    ligne.lignesCommande.forEach((ligneCommandeN) => {
      ligneCommandeN.dateDebut = formatDate(ligneCommandeN.dateDebut);
      ligneCommandeN.dateFin = formatDate(ligneCommandeN.dateFin);
    });
  });
  commande.echeanciers.map(echeancier => {
    echeancier.dateDebut = formatDate(echeancier.dateDebut);
    echeancier.dateFin = formatDate(echeancier.dateFin);
    echeancier.dateFinPremiereEcheance = formatDate(echeancier.dateFinPremiereEcheance);
    echeancier.echeancierLignes.map(echeancierLigne => {
      if (echeancierLigne.fromGeneration) delete echeancierLigne.id;
      echeancierLigne.dateDebut = formatDate(echeancierLigne.dateDebut);
      echeancierLigne.dateFin = formatDate(echeancierLigne.dateFin);
      echeancierLigne.datePrevisionnelleFacturation = formatDate(
        echeancierLigne.dateDebut ?? new Date());
      echeancierLigne.dateBonAFacturer = formatDate(echeancierLigne.dateBonAFacturer);
      if (echeancierLigne.facture) {
        echeancierLigne.facture.dateDevisCommande = formatDate(
          echeancierLigne.facture.dateDevisCommande);
      }
      return echeancierLigne;
    });
    return echeancier;
  });
  delete commande.commercial;
  return commande;
}
